// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationConfirmEmailPath = 'M59 49h-7V36H40.375A21.422 21.422 0 0146 50.5V74h44V50.5C90 42.492 83.508 36 75.5 36H59v13zM39 81v17h30V81h28V50.5C97 38.626 87.374 29 75.5 29H59v-6h9.5C74.299 23 79 18.299 79 12.5V2H62.5C56.701 2 52 6.701 52 12.5V29H24.5C12.626 29 3 38.626 3 50.5V81h36zm0-7V50.5C39 42.492 32.508 36 24.5 36S10 42.492 10 50.5V74h29zm7 7h16v10H46V81zm13-65h9.5a3.5 3.5 0 003.5-3.5V9h-9.5a3.5 3.5 0 00-3.5 3.5V16zM13.1 59.2l8.9 9.7 14.5-18.8-5.5-4.2-9.5 12.2-3.2-3.6-5.2 4.7z';
var IllustrationConfirmEmail = baseIllustration('IllustrationConfirmEmail', {
  getPath: () => IllustrationConfirmEmailPath
}, 'ColoredIllustrationConfirmEmail');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationConfirmEmail;
//# sourceMappingURL=index.js.map